/* 菜单请求模块 */
import {
    axiosPost,
    axiosPatch,
    axiosDelete,
    axiosGet
} from '@/untils/http'


// 获取当前用户动态菜单
export const userMenuTree = (parmas) => axiosGet('/tenantMenu/listByTenantId', parmas)

// 获取菜单管理的菜单
export const menuTree = (parmas) => axiosGet('/menu/listTree', parmas)
export const menuTreeAcl = (parmas) => axiosGet('/menu/listTreeAcl', parmas)
// 获取菜单
//export const menulist = (parmas) => axiosGet('/menu/listTree', parmas)

// 保存菜单
export const addMenu = (data) => axiosPost('/menu', data)

// 编辑菜单
export const editMune = (data) => axiosPatch('/menu/'+data.id,data)

// 删除菜单
export const deleteMune = (parmas) => axiosDelete('/menu/'+parmas)



// WEBPACK FOOTER //
// ./src/api/menu.js